import { SvgAppApi } from '@svg/app-api';

const javascriptBridge = new SvgAppApi({
  debug: ['dev', 'test'].includes(process.env.VUE_APP_ENV),
});

export default javascriptBridge;
